import React, { useEffect, useState } from 'react';
import "./OrientationChange.css";

function OrientationChange () {
    let [ landscape, setLandscape ] = useState( false );

    window.addEventListener( "orientationchange", () => {
        let width = document.querySelector( ".App" ).clientWidth;
        let height = document.querySelector( ".loader-container" ).clientHeight;
        if ( width < 432 || height < 432 ) {
            if ( window.screen.orientation.type === "landscape-primary" ) {
                setLandscape( true );
            } else {
                setLandscape( false );
            }
        }
    } )

    useEffect( () => {
        let width = document.querySelector( ".App" ).clientWidth;
        let height = document.querySelector( ".loader-container" ).clientHeight;
        if ( width < 432 || height < 432 ) {
            if ( window.screen.orientation.type === "landscape-primary" ) {
                setLandscape( true );
            }
        }
    }, [] )

    return (
        <>
            {landscape === true && <div className='orientation-container'>
                <img src={require( "../../images/rotate-image.webp" )} height={"50%"} alt="" />
                <div>
                    We don’t support Landscape mode yet. Please go back to Portrait mode for the best experience
                </div>
                <a href="https://www.linkedin.com/in/shivendra18/" rel="noreferrer">
                    Designed and Developed by <font color="#215B5F">Shivendra Mall</font>
                </a>
            </div>}
        </>
    )
}

export default OrientationChange